import styled from "styled-components";

type TableCellProps = {
    $width?: string;
}
export const Table = styled.table`
    width: 100%;
    color: var(--main-grey-color);
    border-collapse: collapse;
    border: 2px solid var(--main-light-grey-color);
`;
export const TableCell = styled.td<TableCellProps>`
    vertical-align: top;
    text-align: left;
    font-size: 0.8rem;
    width: ${props => props.$width};
    padding: 1em;
    line-height: 1em;
    border: 2px solid var(--main-light-grey-color);
    line-height: 1.5em;
`;
export const CellHeader = styled.p`
    font-size: 0.8rem;
    padding-bottom: 1em;
    font-family: Poppins-SemiBold;
`;
export const CellBody = styled.p`
    font-size: 0.7rem;
`;